import React, { Fragment } from 'react';
import styled from 'styled-components';
import { useControlValue } from '../../Contexts/ControlContext';
import { Button } from '../../Common/Button';
import { TemplateOne } from '../../Templates/Template-1';
import { TemplateTwo } from '../../Templates/Template-2';
import { TemplateThree } from '../../Templates/Template-3';
import { TemplateFour } from '../../Templates/Template-4';
import { TemplateFive } from '../../Templates/Template-5';
import { TemplateSix } from '../../Templates/Template-6';
import { copyToClipboard } from '../../Common/CopyToClipboard';

interface PreviewProps {}

export const Preview = () => {
  const { data } = useControlValue();

  const currentTemplate = () => {
    switch (data.template) {
      case 'template1':
        return <TemplateOne />;
      case 'template2':
        return <TemplateTwo />;
      case 'template3':
        return <TemplateThree />;
      case 'template4':
        return <TemplateFour />;
      case 'template5':
        return <TemplateFive />;
      case 'template6':
        return <TemplateSix />;
      default:
        return <TemplateOne />;
    }
  };

  return (
    <Fragment>
      <StyledPreview>{currentTemplate()}</StyledPreview>

      <strong>Step 2.</strong>
      <p>Click the button below to copy the signature</p>

      <Button onClick={() => copyToClipboard('signatureMarkup')}>
        Copy Signature
      </Button>
    </Fragment>
  );
};

const StyledPreview = styled.article`
  margin-bottom: 5rem;
`;
